import React from 'react';
export function CatalogSection() {
  return <div className="mt-8" data-id="element-1674">
      <div className="bg-[#1874cd] py-8 px-4" data-id="element-1675">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center" data-id="element-1676">
          GF Machining Solutions EDM Consumables Catalog
        </h2>
      </div>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-1677">
        <div className="grid md:grid-cols-2 gap-12 items-center bg-white p-8 md:p-12 rounded-xl shadow-sm border border-gray-200" data-id="element-1678">
          <div className="space-y-4 text-center md:text-left" data-id="element-1679">
            <h3 className="text-2xl font-bold text-navy mb-6" data-id="element-1680">Shop for:</h3>
            <ul className="space-y-3 text-lg font-medium text-gray-700" data-id="element-1681">
              <li data-id="element-1682">• EDM Wire</li>
              <li data-id="element-1683">• Filters for EDM Machines</li>
              <li data-id="element-1684">• Deionization Systems</li>
              <li data-id="element-1685">• Dielectrics</li>
              <li data-id="element-1686">• Graphite Electrodes</li>
              <li data-id="element-1687">• Metallic Electrodes</li>
              <li data-id="element-1688">• Drilling Electrodes</li>
              <li data-id="element-1689">• EDM Chemicals</li>
              <li data-id="element-1690">• &amp; More</li>
            </ul>
          </div>
          <div className="text-center" data-id="element-1691">
            <a href="https://www.peakedm.com/uploaded/files/GFMS_EDM_Consumables_Catalog.pdf?direct=1" target="_blank" rel="noopener noreferrer" className="inline-block hover:opacity-90 transition-opacity hover:scale-105 transform duration-300" data-id="element-1692">
              <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Consumable/EDM%20Consumables%20Catalog.png" alt="EDM Consumables Catalog" className="block max-w-full h-auto mx-auto shadow-lg rounded-lg" data-id="element-1693" />
            </a>
          </div>
        </div>
      </div>
    </div>;
}